import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { Badge } from '../common';
import { Routes } from '../../config/Routes';
import { isInternalUser } from '../../redux/reducers/AuthReducer';
import { isOneKeyPaymentsPanel, isTupayPanel, isD24Panel } from '../../utils/panelUtils';

class NavBarSubmenu extends Component {
  state = {
    showMenu: false,
    submenuTopPosition: 0,
    clicked: false,
  };

  constructor(props) {
    super(props);
    this.menuItemReference = React.createRef();
  }

  componentDidMount = () => {
    const { active } = this.props;
    const submenuTopPosition = this.menuItemReference.current.offsetTop;
    this.setState({ submenuTopPosition, showMenu: active });
  };

  toggleMenu = (e) => {
    e.preventDefault();
    const { showMenu } = this.state;
    this.setState({
      showMenu: !showMenu,
      clicked: true,
    });
  };

  getSubMenuStyle = () => {
    const { navbarScrollTop } = this.props;
    const { submenuTopPosition } = this.state;
    const top = submenuTopPosition - navbarScrollTop + 50;
    return {
      top,
    };
  };

  getSubMenuClasses = () => {
    const { showMenu, clicked } = this.state;
    const { active } = this.props;
    return {
      liElem: classNames({
        'navbar-item': true,
        dropup: showMenu,
      }),
      linkElem: classNames({
        'navbar-link update-icon': true,
        active,
      }),
      subMenuElem: classNames({
        'd-none': (clicked && !showMenu) || (!showMenu && !active),
        'sub-menu': true,
      }),
    };
  };

  renderSubMenu = (items) => {
    const { t, path, isInternalUser } = this.props;
    
    return items
      .filter(item => this.shouldShowMenuItem(item.route, isInternalUser))
      .map(({ route, text, icon, badge: { tooltip, action } = {} }) => (
        <li id={`${text}-navbar-sub-item-li`} className="navbar-sub-item" key={text}>
          <Link 
            id={`${text}-navbar-sub-link`} 
            to={route} 
            className={classNames('navbar-sub-link', { active: path === route })}
          >
            <span id={`${text}-navbar-sub-item-icon-span`} className="navbar-item-icon">
              {this.renderIcon(icon, text)}
              {action && <Badge action={action} tooltip={tooltip} />}
            </span>
            <span id={`${text}-navbar-sub-item-text-span`} className="navbar-item-text">
              {t(`nav${text}`)}
            </span>
          </Link>
        </li>
      ));
  };

  renderIcon = (icon, text) => {
    if (icon === 'all-transactions-icon') {
      return (
        <>
          <FontAwesomeIcon 
            className="all-transactions level-down" 
            icon={{ prefix: 'fal', iconName: 'long-arrow-down' }} 
            size="lg" 
            id={text} 
          />
          <FontAwesomeIcon 
            className="all-transactions" 
            icon={{ prefix: 'fal', iconName: 'long-arrow-up' }} 
            size="lg" 
            id={text} 
          />
        </>
      );
    }
    
    return <FontAwesomeIcon icon={{ prefix: 'fal', iconName: icon }} size="lg" id={text} />;
  };

  shouldShowMenuItem = (route, isInternalUser) => {
    if (route === Routes.BALANCE_REPORT_WALLET) {
      return isInternalUser && (isOneKeyPaymentsPanel || isD24Panel);
    }
    
    if (route === Routes.WALLET_TRANFER) {
      return !isTupayPanel && !isInternalUser;
    }
    
    return true;
  };

  render() {
    const { icon, text, items } = this.props;
    const classes = this.getSubMenuClasses();
    const subMenuStyle = this.getSubMenuStyle();
    return (
      <Fragment>
        <li id={`${text}-navbar-item-li`} ref={this.menuItemReference} className={classes.liElem}>
          <div id={`${text}-navbar-item-div`} className={classes.linkElem} onClick={this.toggleMenu}>
            <span id={`${text}-navbar-item-icon-span`} className="navbar-item-icon">
              <FontAwesomeIcon icon={{ prefix: 'fal', iconName: icon }} size="lg" />
            </span>
            <span id={`${text}-navbar-item-text-span`} className="navbar-item-text dropdown-toggle">{text}</span>
          </div>
          <ul id={`${text}-navbar-item-ul`} style={subMenuStyle} className={classes.subMenuElem}>
            {this.renderSubMenu(items)}
          </ul>
        </li>
      </Fragment>
    );
  }
}

NavBarSubmenu.propTypes = {
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  navbarScrollTop: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  isInternalUser: isInternalUser(state), // Ensure `isInternalUser` is a selector or derived value
});

export default connect(mapStateToProps)(withNamespaces()(NavBarSubmenu));
